import {
    ADMIN_BUDGET_LOCATION,
    BUDGET_AS_RESOURCE_LOCATION,
    BUDGET_OVERVIEW_LOCATION,
    DASHBOARDS_LOCATION,
    EXPLORER_LOCATION,
    HOME_LOCATION,
    HR_PAY_STATE_HOME_LOCATION,
    HR_SIMULATION_HOME_LOCATION,
    INDICATORS_LOCATION,
    LOCATION_MAPPING,
    SUPPORT_LOCATION,
    SETTINGS_LOCATION,
    HR_SIMULATION_ITEM_LOCATION,
    HR_PAY_STATE_ITEM_LOCATION,
    HR_RETROSPECTIVE_HOME_LOCATION,
    HR_RETROSPECTIVE_ITEM_LOCATION,
} from 'business/constants';
import { CHARTS_TEMPLATES_PATHNAME } from 'components/App/components/routes';

export const checkHomeSelected = (pathname: string) => {
    const subLocation = pathname.split('/')[1];
    return LOCATION_MAPPING[subLocation] === HOME_LOCATION;
};

export const checkDashboardsSelected = (pathname: string) => {
    const subLocation = pathname.split('/')[1];

    return LOCATION_MAPPING[subLocation] === DASHBOARDS_LOCATION;
};
export const checkIndicatorsSelected = (subLocation: string) =>
    LOCATION_MAPPING[subLocation] === INDICATORS_LOCATION;

export const checkExploreSelected = (subLocation: string) =>
    LOCATION_MAPPING[subLocation] === EXPLORER_LOCATION;

export const checkBudgetAsResourceSelected = (subLocation: string) =>
    LOCATION_MAPPING[subLocation] === BUDGET_AS_RESOURCE_LOCATION;

export const checkBudgetOverviewSelected = (subLocation: string) =>
    LOCATION_MAPPING[subLocation] === BUDGET_OVERVIEW_LOCATION;

export const checkBudgetAdminSelected = (subLocation: string) =>
    LOCATION_MAPPING[subLocation] === ADMIN_BUDGET_LOCATION;

export const checkLocationInBackOffice = (subLocation: string) =>
    LOCATION_MAPPING[subLocation] === SUPPORT_LOCATION;

export const checkPayStateHomeSelected = (subHrLocation: string) =>
    LOCATION_MAPPING[subHrLocation] === HR_PAY_STATE_HOME_LOCATION;

export const checkPayStateItemSelected = (subHrLocation: string) =>
    LOCATION_MAPPING[subHrLocation] === HR_PAY_STATE_ITEM_LOCATION;

export const checkRetrospectiveHomeSelected = (subHrLocation: string) =>
    LOCATION_MAPPING[subHrLocation] === HR_RETROSPECTIVE_HOME_LOCATION;
export const checkRetrospectiveItemSelected = (subHrLocation: string) =>
    LOCATION_MAPPING[subHrLocation] === HR_RETROSPECTIVE_ITEM_LOCATION;
export const checkHrSimulationHomeSelected = (subHrLocation: string) =>
    LOCATION_MAPPING[subHrLocation] === HR_SIMULATION_HOME_LOCATION;

export const checkHrSimulationItemSelected = (subHrLocation: string) =>
    LOCATION_MAPPING[subHrLocation] === HR_SIMULATION_ITEM_LOCATION;

export const checkHrSettingsSelected = (pathname: string) =>
    LOCATION_MAPPING[pathname] === SETTINGS_LOCATION;

export const checkBackOfficeChartsTemplatesSelected = (pathname: string) =>
    pathname === CHARTS_TEMPLATES_PATHNAME;
